(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["email-capture"]) return;
  try {
    

$el = $('#shopify-section-email-capture')
if (!$el.children().length) {
  return;
}

var email = $.deparam.querystring().email;

if (email == 'reset') {
  Cookies.remove('email_dismissed');
  Cookies.remove('email_collected');
}

if (Cookies.get('email_dismissed') == 'true' || Cookies.get('email_collected') == 'true') {
  $('#shopify-section-email-capture').hide();

} else {

  $($el).on('click', '.js-email-close',  function(e) {
    $el.removeClass('visible');
    Cookies.set('email_dismissed', 'true');
  })

  onSignupSubmit($el, {
    success: function() {
      setTimeout(function() {
        $el.removeClass('visible')
      }, 2000);
    }
  });
  setTimeout(function() {
    $el.addClass('visible')
  }, 5000)
}

$(document).on('shopify:section:load, shopify:section:select', $('#shopify-section-email-capture'), function(e) {
  $(e.target).show().addClass('visible')
})

$('.js-email-close',$el).on('click', function(e) {
  $el.removeClass('visible');
})


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  function onScroll(e) {
    var st = $(this).scrollTop();
    var windowHeight = window.innerHeight ? window.innerHeight : $(window).height();
    var footerOffset = $('#shopify-section-footer').offset().top;
    if (st + windowHeight > footerOffset) {
      $('body').addClass('footer-in-view');
    } else {
      $('body').removeClass('footer-in-view');
    }
  }
  onScroll();
  throttled = _.throttle(onScroll, 20 );
  if (window.addEventListener) {
    window.addEventListener('scroll', throttled, false);
    window.addEventListener('resize', throttled, false);
  } else if (window.attachEvent) {
    window.attachEvent('onscroll', throttled);
    window.attachEvent('resize', throttled);
  }
  onSignupSubmit($('#shopify-section-footer'));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
   //add no-announcement-bar class
   if (document.querySelectorAll('.announcement-bar').length === 0) {
    document.querySelector('#shopify-section-header').classList.add('no-announcement-bar');
   }
  var lastScrollTop = 0;
  function didScroll(e) {
    var st = $(this).scrollTop();
    var $header = $('#shopify-section-header');
    var headerHeight = $header.outerHeight();
    if (st <= 0) {
      $('.header-inner', $header).css({ position: 'static', top: -headerHeight });
      $('body').addClass('header-visible');

    } else if (st > lastScrollTop) {
      // downscroll code

      if (st > headerHeight) {
        $('.header-inner', $header).css({ position: 'fixed', top: -headerHeight });
        $('body').removeClass('header-visible');
      }
    } else {
      // upscroll code

      $('.header-inner', $header).css({ top: 0 });
      $('body').addClass('header-visible');
    }

    lastScrollTop = st;
  }

  didScroll();


  throttled = _.throttle(didScroll, 20 );
  if (window.addEventListener) {
    window.addEventListener('scroll', throttled, false);
  } else if (window.attachEvent) {
    window.attachEvent('onscroll', throttled);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-columns"] && !Shopify.designMode) return;
  try {
    
  $('.homepage-columns--mobile').on('click', function(e) {
    $container = $(this);
    if ($container.is('.expanded')) {
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    $('.bottom', $container).one('transitionend', function(e) {

      // Remove button and gradient after minimizing them
      // $container.one('transitionend', function(e) {
        $('.bottom', $container).remove();
      // });



      // Unset max-height after expansion so window may be resized without clipping
      $container.attr({ style: "max-height: none" });
    });

     // Minimize gradient
      $container.addClass('expanded');

    // Expand container to content hight
    var contentHeight = $('.homepage-columns--mobile-inner', $container).outerHeight(true);
    $container.attr({ style: "max-height: " + contentHeight + "px" })

    // Hide button text
    $('.read-more a', $container).hide();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-video"] && !Shopify.designMode) return;
  try {
    
  initVideos();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-arrow"]) return;
  try {
    
  $(window).on('resize scroll', function() {
    if ($(window).scrollTop() > $(window).height() * .25) {
      $('#shopify-section-scroll-arrow').addClass('hidden');
    } else {
      $('#shopify-section-scroll-arrow').removeClass('hidden');
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["side-cart"]) return;
  try {
    
function showCart() {
  $('body').addClass('cart-visible');
}

function hideCart() {
  $('body').removeClass('cart-visible');
}

function toggleCart() {
  $('body').toggleClass('cart-visible');
}
$(document).on('cart.requestStarted', function() {
  showCart();
  $('form[action^="/cart"] [type="submit"]').prop('disabled', true);
});

$(document).on('cart.requestComplete', function() {
  $('form[action^="/cart"] [type="submit"]').prop('disabled', false);
  affirm.ui.refresh();
});

$(document).on('click', '.js-show-cart', function(e) {
  e.preventDefault();
  showCart();
});

$(document).on('click', '.js-toggle-cart', function(e) {
  e.preventDefault();
  toggleCart();
});

$(document).on('click', '.js-hide-cart', function(e) {
  e.preventDefault();
  hideCart();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidebar"]) return;
  try {
    
  function startTime() {
    var today = new Date();
    var h = today.getHours();
    var m = today.getMinutes();
    var s = today.getSeconds();
    m = checkTime(m);
    s = checkTime(s);
    $('.js-time-now').html(h + ":" + m + ":" + s);
    var t = setTimeout(startTime, 500);
  }
  function checkTime(i) {
    if (i < 10) {i = "0" + i};  // add zero in front of numbers < 10
    return i;
  }
startTime();

  } catch(e) { console.error(e); }
})();
})();
